import { gql, useMutation } from '@apollo/client'
import * as chrono from 'chrono-node'
import MultiUseDiscountCodeForm, {
  FormValues,
  validationSchema,
} from 'components/Dashboard/DiscountCodes/MultiUseDiscountCodeForm'
import { Formik } from 'formik'
import {
  CreateMultiUseDiscountCodeMutation,
  CreateMultiUseDiscountCodeMutationVariables,
} from './__generated__/CreateMultiUseDiscountCodeMutation'

const casualGbChrono = new chrono.Chrono(chrono.en.createCasualConfiguration(true))

const createMultiUseDiscountCodeMutation = gql`
  mutation CreateMultiUseDiscountCodeMutation($input: CreateMultiUseDiscountCodeInput!) {
    createMultiUseDiscountCode(input: $input) {
      code
    }
  }
`

interface NewMultiUseDiscountCodeProps {
  thirdPartyId: string
  onSuccess: (discountCode: string) => void
}

const NewMultiUseDiscountCode = ({ thirdPartyId, onSuccess }: NewMultiUseDiscountCodeProps) => {
  const [createMultiUseDiscountCode] = useMutation<
    CreateMultiUseDiscountCodeMutation,
    CreateMultiUseDiscountCodeMutationVariables
  >(createMultiUseDiscountCodeMutation)

  return (
    <Formik<FormValues>
      onSubmit={async (values) => {
        const response = await createMultiUseDiscountCode({
          variables: {
            input: {
              thirdPartyId,
              startDate: casualGbChrono.parseDate(values.startDate).toISOString().substring(0, 10),
              endDate: casualGbChrono.parseDate(values.endDate).toISOString().substring(0, 10),
              reference: values.ref,
            },
          },
        })

        const code = response?.data?.createMultiUseDiscountCode?.code
        if (code) {
          onSuccess(code)
        }
      }}
      validationSchema={validationSchema}
      initialValues={{ startDate: '', endDate: '', ref: '' }}
    >
      <MultiUseDiscountCodeForm />
    </Formik>
  )
}

export default NewMultiUseDiscountCode
